"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.homeReducer = void 0;
var HomeAction_1 = require("@/pages/home/actions/HomeAction");
var HomeState_init_1 = require("@/pages/home/states/HomeState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.homeReducer = function (state, action) {
    if (state === void 0) { state = HomeState_init_1.defaultHomeState; }
    switch (action.type) {
        case typesafe_actions_1.getType(HomeAction_1.default.onCalcDownpayChanged): {
            return __assign(__assign({}, state), { calcDownpayValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onCalcMonthlyChanged): {
            return __assign(__assign({}, state), { calcMonthlyValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onCalcDurationChanged): {
            return __assign(__assign({}, state), { calcTenorValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onCalcRateChanged): {
            return __assign(__assign({}, state), { calcRateValue: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.calcTenorIncr): {
            if (state.calcTenorValue === state.calcTenorMax)
                return state;
            return __assign(__assign({}, state), { calcTenorValue: state.calcTenorValue + state.calcTenorStep });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.calcTenorDecr): {
            if (state.calcTenorValue === state.calcTenorMin)
                return state;
            return __assign(__assign({}, state), { calcTenorValue: state.calcTenorValue - state.calcTenorStep });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.calcRateIncr): {
            if (state.calcRateValue === state.calcRateMax)
                return state;
            return __assign(__assign({}, state), { calcRateValue: Math.ceil((state.calcRateValue + state.calcRateStep) * 1000) / 1000 });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.calcRateDecr): {
            if (state.calcRateValue === state.calcRateMin)
                return state;
            return __assign(__assign({}, state), { calcRateValue: Math.ceil((state.calcRateValue - state.calcRateStep) * 1000) / 1000 });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setIsSaved): {
            return __assign(__assign({}, state), { properties: state.properties.map(function (it) { return (Number(it.referenceId) === action.payload.id)
                    ? __assign(__assign({}, it), { isSaved: action.payload.state })
                    : it; }) });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setIsSavedRange): {
            return __assign(__assign({}, state), { properties: state.properties.map(function (it) { return action.payload.ids.indexOf(Number(it.referenceId)) >= 0
                    ? __assign(__assign({}, it), { isSaved: action.payload.state })
                    : it; }) });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onFeaturePrevClick): {
            var currentIndex = state.featureSliderIndex;
            var slideCount = state.features.length;
            var prevIndex = currentIndex === 0 ? slideCount - 1 : currentIndex - 1;
            return __assign(__assign({}, state), { featureSliderIndex: prevIndex });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onFeatureNextClick): {
            var currentIndex = state.featureSliderIndex;
            var slideCount = state.features.length;
            var nextIndex = currentIndex === slideCount - 1 ? 0 : currentIndex + 1;
            return __assign(__assign({}, state), { featureSliderIndex: nextIndex });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.onSearchInputTextChanged): {
            return __assign(__assign({}, state), { searchInputText: action.payload, searchSuggestionActive: true, searchLoading: true, searchSuggestionGroups: [], searchSuggestionGroupIndex: -1, searchSuggestionRowIndex: -1 });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setLoading): {
            return __assign(__assign({}, state), { searchSuggestionActive: true, searchLoading: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setSuggestionGroups): {
            return __assign(__assign({}, state), { searchSuggestionActive: (action.payload && action.payload.length) ? true : false, searchLoading: false, searchSuggestionGroups: action.payload, searchSuggestionGroupIndex: -1, searchSuggestionRowIndex: -1 });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setSuggestionGroupRowIndex): {
            var _a = action.payload, groupIndex = _a.groupIndex, rowIndex = _a.rowIndex;
            return __assign(__assign({}, state), { searchSuggestionGroupIndex: groupIndex, searchSuggestionRowIndex: rowIndex });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setSearchInputText): {
            return __assign(__assign({}, state), { searchInputText: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setFullscreenLoading): {
            return __assign(__assign({}, state), { fullscreenLoading: action.payload });
        }
        case typesafe_actions_1.getType(HomeAction_1.default.setTestimonialAutoplay): {
            return __assign(__assign({}, state), { isTestimonialAutoPlay: action.payload });
        }
    }
    return state;
};
